import { render, staticRenderFns } from "./TeacherGeneralForm.vue?vue&type=template&id=16ed7d02&scoped=true"
import script from "./TeacherGeneralForm.vue?vue&type=script&lang=js"
export * from "./TeacherGeneralForm.vue?vue&type=script&lang=js"
import style0 from "./TeacherGeneralForm.vue?vue&type=style&index=0&id=16ed7d02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ed7d02",
  null
  
)

export default component.exports